import {defineMessage, MessageDescriptor} from 'react-intl'

import {
  TopDealsDestination,
  topDealsDestinations
} from '@vio/core/src/brand/config/topDealsDestinations'

export interface City {
  name: MessageDescriptor
  placeId: string
}

export interface TranslatedCity {
  name: string
  placeId: string
}

const nearMe: City = {
  name: defineMessage({id: 'nearMe', defaultMessage: 'Near me'}),
  placeId: undefined
}

const northAmericaDestinations = [
  TopDealsDestination.LasVegas,
  TopDealsDestination.NewYork,
  TopDealsDestination.Cancun,
  TopDealsDestination.NiagaraFalls,
  TopDealsDestination.Tokyo
]

const worldwideDestinations = [
  TopDealsDestination.Dubai,
  TopDealsDestination.London,
  TopDealsDestination.Istanbul,
  TopDealsDestination.Paris,
  TopDealsDestination.Singapore
]

const withNearMe = (destinations: TopDealsDestination[]): City[] => [
  nearMe,
  ...destinations.map(destination => topDealsDestinations[destination])
]

export const getCitiesData = (
  country: string,
  brandDestinations: TopDealsDestination[] | null
): City[] => {
  if (brandDestinations) return withNearMe(brandDestinations)
  if (['US', 'CA'].includes(country))
    return withNearMe(northAmericaDestinations)
  return withNearMe(worldwideDestinations)
}
